import React, { Fragment, useState, useContext } from "react";
import axios from "axios";
import Modal from "react-modal";
import scroll from "@threespot/freeze-scroll";

import { EligibilityContext } from "../../contexts/EligibilityContext";

import FundReopenNotificationsForm from "./FundReopenNotificationsForm";
import Icon from "../Icon";
import APIError from "../APIError";

Modal.setAppElement("body");

export default function FundReopenNotifications({
  data,
  inEligibilityWizard = null,
}) {
  const [duplicateSubmission, setDuplicateSubmission] = useState(false);
  const [duplicatePatient, setDuplicatePatient] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errorEncountered, setErrorEncountered] = useState(false);
  const context = useContext(EligibilityContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [role, setRole] = useState("patient");

  function openModal() {
    setModalOpen(true);
    scroll.freeze();
  }

  function closeModal() {
    setModalOpen(false);
  }

  function reset() {
    setSubmitted(false);
    setDuplicateSubmission(false);
    setDuplicatePatient(false);
    setErrorEncountered(false);
    scroll.unfreeze();
  }

  const submitHandler = async (formData) => {
    const requestUrl = `/wp-json/salesforce/v1/funds/${data.Fund_ID}/waitlist`;
    const requestBody = {
      personal_details: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formData.phone,
        email: formData.email,
        socialSecurityNumber: `${formData.ssn1}${formData.ssn2}${formData.ssn3}`,
      },
    };

    await axios.post(requestUrl, requestBody).then(() => {
      setRole(formData.role);
      setSubmitted(true);
    });
  };

  const DuplicateSubmission = () => {
    return (
      <Fragment>
        <div className="u-center">
          <Icon name="circleExclamation" width={44} height={44} />
          <p
            className="f-h4 c-purple u-mt3 u-mb2"
            style={{ maxWidth: "410px", margin: "0 auto" }}
          >
            Someone has already used this social security number to sign up.
          </p>
        </div>

        <div className="u-richtext">
          <p style={{ margin: 0 }}>
            If you need further assistance, call{" "}
            <b>
              <a href="tel:18663167263">1-866-316-7263</a>
            </b>
            . If you feel you made a mistake, please try{" "}
            <button onClick={reset} className="btn-reset f-link">
              entering the information again
            </button>
            .
          </p>
        </div>
      </Fragment>
    );
  };

  const DuplicatePatient = () => {
    return (
      <Fragment>
        <div className="u-center">
          <Icon name="circleExclamation" width={44} height={44} />
          <p
            className="f-h4 c-purple u-mt3 u-mb2"
            style={{ maxWidth: "410px", margin: "0 auto" }}
          >
            {role === "patient" && (
              <Fragment>
                You are already signed up for this Disease Fund Wait List.
              </Fragment>
            )}

            {(role === "provider" || role === "pharmacist") && (
              <Fragment>
                The patient is already signed up for this Disease Fund Wait
                List.
              </Fragment>
            )}
          </p>
        </div>

        <div className="u-richtext">
          <p style={{ margin: 0 }}>
            The provided patient information already exists in our records. If
            the fund reopens, we will send the email on record an application
            request. If you need further assistance, call{" "}
            <b>
              <a href="tel:18663167263">1-866-316-7263</a>
            </b>
            . If you feel you made a mistake, please try{" "}
            <button onClick={reset} className="btn-reset f-link">
              entering the information again
            </button>
            .
          </p>
        </div>
      </Fragment>
    );
  };

  const Success = () => {
    return (
      <Fragment>
        <div className="u-center">
          <Icon name="circleCheck" width={44} height={44} />
          <p
            className="f-h4 c-purple u-mt3 u-mb2"
            style={{ maxWidth: "410px", margin: "0 auto" }}
          >
            {role === "patient" && (
              <Fragment>
                You are signed up for this Disease Fund Wait List
              </Fragment>
            )}

            {(role === "provider" || role === "pharmacist") && (
              <Fragment>
                The patient is signed up for this Disease Fund Wait List.
              </Fragment>
            )}
          </p>
        </div>

        <div className="u-richtext">
          <p style={{ margin: 0 }}>
            If the fund reopens, we will send the email(s) on record an
            application request. If you need further assistance, call{" "}
            <b>
              <a href="tel:18663167263">1-866-316-7263</a>
            </b>
            .
          </p>
        </div>
      </Fragment>
    );
  };

  const Inner = () => {
    return (
      <Fragment>
        {duplicateSubmission && <DuplicateSubmission />}

        {duplicatePatient && <DuplicatePatient />}

        {errorEncountered && <APIError />}

        {!errorEncountered && !duplicateSubmission && !duplicatePatient && (
          <Fragment>
            {submitted && <Success />}
            {!submitted && (
              <FundReopenNotificationsForm submitHandler={submitHandler} />
            )}
          </Fragment>
        )}
      </Fragment>
    );
  };

  // If this component is being rendered within the eligibility wizard flow just render the contents of the modal.
  // The eligibility wizard already manages its own wrapper modal.
  if (inEligibilityWizard) {
    return <Inner />;
  }

  return (
    <Fragment>
      {/* <button type="button" className="btn" onClick={openModal}>
        Sign up
      </button> */}
      <button type="button" className="btn" onClick={openModal}>
        Join the wait list
      </button>

      <Modal
        isOpen={modalOpen}
        className="Modal Modal--large"
        overlayClassName="Modal-overlay"
        onAfterClose={reset}
        closeTimeoutMS={600} // timeout must equal CSS animation duration
      >
        <div className="Modal-inner">
          <div className="Card">
            <div className="Card-inner">
              <div className="Card-inner-content">
                <Inner />
              </div>
            </div>
          </div>

          <button onClick={closeModal} className="Modal-close">
            <Icon className="Modal-close-icon" name="close" />
            <span className="u-screenreader">Close</span>
          </button>
        </div>
      </Modal>
    </Fragment>
  );
}
